import QuantModelDetailsPage from "./QuantModelDetailsPage";

export default QuantModelDetailsPage;
